import { AuthRepository } from "../repositories/AuthRepository";
import { AuthResultEntity, LoginCredentials } from "../entities/AuthResult";

/**
 * Login Use Case
 * Handles user login business logic
 */
export class LoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Execute login
   * @param credentials - User credentials
   * @returns Authentication result with user, company, and token
   */
  async execute(credentials: LoginCredentials): Promise<AuthResultEntity> {
    // Validate credentials
    if (!credentials.email || !credentials.password) {
      throw new Error("Email and password are required");
    }

    if (!this.isValidEmail(credentials.email)) {
      throw new Error("Invalid email format");
    }

    // Perform login through repository
    const result = await this.authRepository.login(credentials);

    // Check if Zoho authentication is needed
    const needsZohoAuth = !result.user.zohoRefreshToken;

    return {
      ...result,
      needsZohoAuth,
    };
  }

  /**
   * Validate email format
   */
  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
